export default __webpack_public_path__ + "static/diginnova-white-barra-nera-1652ee626474c5419a0b39dc0bd63a7d.svg";